import lobo from "./lobo_pl.png";
import { Link } from 'react-router-dom';
import styled from "styled-components";
import { useState } from 'react';

const StyledLink = styled(Link)`
  text-decoration: none;
  color: white;
  padding: 40px;
  font-size: 20px;

  &:hover {
    background-color: black;
    color: white;
  }

  @media (max-width: 750px) {
    font-size: 13px;
    padding: 18px;
  }
`;

function NavBar() {
    return (
        <div>
            <section id="mainNav">
                    <div id="navItems">
                        <img id="navImage" src={lobo}></img>
                        <StyledLink to='/'>Home</StyledLink>
                        <StyledLink to='/join'>Join</StyledLink>
                        <StyledLink to='/contact'>Contact</StyledLink>
                        <StyledLink to='/support'>Support Us</StyledLink>
                    </div>
            </section>
        </div>
    );
}

export default NavBar;
